import { Locale, getLocale } from '@libs/core';

const locale = getLocale();

const clientName = locale === Locale['en-CA'] ? 'petsmart-canada' : 'petsmart';
const siteID = 'main_site';
const scriptLocale = getLocale().replace('-', '_');
const environment = process.env.NEXT_PUBLIC_BV_ENVIRONMENT ?? 'staging';

const src = `https://apps.bazaarvoice.com/deployments/${clientName}/${siteID}/${environment}/${scriptLocale}/bv.js`;

export const BAZAAR_VOICE_SCRIPT_SRC = src;
